import { Component, effect, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [MatIcon, TranslatePipe],
  selector: 'iot-platform-ui-image-selector-v2',
  templateUrl: './image-selector-v2.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-selector-v2.component.scss']
})
export class ImageSelectorV2Component {
  images = input<string[]>([]);
  initialImage = input<string | null>(null);
  defaultImage = input<string | null>(null);
  selectImage = output<string>();

  selectedImage = signal<string | null>(null);

  initSelectedImageEffect = effect(() => {
    const initialImage = this.initialImage();
    const defaultImage = this.defaultImage();
    this.selectedImage.set(initialImage ?? defaultImage);
  });

  emitselectImageEventEffect = effect(() => {
    const selectedImage = this.selectedImage();
    this.selectImage.emit(selectedImage ?? this.defaultImage() ?? '');
  });

  onSelect(image: string): void {
    this.selectedImage.set(image);
  }

  onImageError(): void {
    this.selectedImage.set(this.defaultImage());
  }
}
